import { fromEvent } from "rxjs";
import { onMessageFromWebApp, sendMessageToWebApp, isBrowser } from "./webAppMessenger";
import { URL_NEW, URL_GO, URL_OPEN, URL_OPEN_IN_BROWSER } from "./messageTypes";

let safariViewControllerAvailable = false;

if (window.SafariViewController) {
  window.SafariViewController.isAvailable(available => {
    safariViewControllerAvailable = available;
  });
}

onMessageFromWebApp(URL_OPEN, ({ url }) => {
  if (safariViewControllerAvailable) {
    window.SafariViewController.show({ url });
  } else {
    // Opens in the system browser, if available
    window.open(url, "_system");
  }
});

onMessageFromWebApp(URL_OPEN_IN_BROWSER, ({ url }) => {
  window.open(url, "_system");
});

if (isBrowser()) {
  let going = false;
  console.log("URL PATH FORWARD TO PARENT FRAME TURNED ON");
  onMessageFromWebApp(URL_GO, ({ go }) => {
    going = true;
    window.history.go(go);
  });

  onMessageFromWebApp(URL_NEW, ({ url, title, replacing }) => {
    going = false;
    if (replacing) {
      window.history.replaceState("", title, url);
    } else {
      window.history.pushState("", title, url);
    }
    if (title) {
      document.title = title;
    }
  });

  fromEvent(window, "popstate").subscribe(() => {
    if (!going) {
      sendMessageToWebApp(URL_NEW, { url: window.location.pathname });
    }
  });
} else {
  console.log("NOT BROWSER");
}

// // Opens a url in a separate view.
// function openUrl(url, usingReaderMode, isHidden) {
//   let readerMode = usingReaderMode || false;
//   let hidden = isHidden || false;

//   return new Promise(resolve => {
//     SafariViewController.isAvailable(function(available) {
//       if (available) {
//         SafariViewController.show(
//           {
//             url: url,
//             hidden: hidden, // default false. You can use this to load cookies etc in the background (see issue #1 for details).
//             animated: false, // default true, note that 'hide' will reuse this preference (the 'Done' button will always animate though)
//             transition: "slide", // (this only works in iOS 9.1/9.2 and lower) unless animated is false you can choose from: curl, flip, fade, slide (default)
//             enterReaderModeIfAvailable: readerMode // default false
//             // tintColor: "#00ffff", // default is iOS blue
//             // barColor: "#0000ff", // on iOS 10+ you can change the background color as well
//             // controlTintColor: "#ffffff" // on iOS 10+ you can override the default tintColor
//           },
//           // this success handler will be invoked for the lifecycle events 'opened', 'loaded' and 'closed'
//           function(result) {
//             if (result.event === "opened") {
//               // Callback on view open
//             } else if (result.event === "loaded") {
//               // Callback on webpage load
//               resolve();
//             } else if (result.event === "closed") {
//               // Callback on view close
//               resolve();
//             }
//           }
//         );
//       } else {
//         // Opens in the system browser, if available
//         window.open(url, "_system", "location=yes");
//         resolve();
//       }
//     });
//   });
// }

// function dismissSafari() {
//   SafariViewController.hide();
// }

// // Attempts to load the url behind the current context. Once it loads, the connection is closed.
// // If SafariViewController is not available, the webpage will NOT be loaded.
// function loadURLInBackground(url) {
//   SafariViewController.isAvailable(available => {
//     if (available) {
//       openUrl(url, false, true).then(() => {
//         dismissSafari();
//       });
//     }
//   });
// }

// window.openUrlWithBrowser = openUrl;
// window.dismissBrowser = dismissSafari;
// window.loadURLInBackground = loadURLInBackground;
